export const ROOT_PATH = '/create';
export const PROFILE_HOME_PATH = '/profile';
export const PROFILE_ROOT_PATH = '/profileCreate';
export const PARTTIME_ROOT_PATH = '/parttimeCreate';
export const FULLTIME_ROOT_PATH = '/fulltimeCreate';
const today = new Date();
// const True = true;
// const False = false;
export const INITIAL_SYSTEM_STATE = {
    resumes: {}
};
export const INITIAL_PARTTIME_RESUME = {
    type: 'parttime',
    resumeName: '',
    basicInfo: {
        lastName: '',
        lastNameKana: '',
        firstName: '',
        firstNameKana: '',
        birthYear: '1990',
        birthMonth: '1',
        birthDay: '1',
        gender: 2,
        genderString: '',
        email: ''
    },
    education: [],
    employment: [],
    certifications: [],
    contact: {
        zip: '',
        address: '',
        addressKana: '',
        buildingName: '',
        phone: '',
        phoneMobile: '',
        preferZip: '',
        preferAddress: '',
        preferAddressKana: '',
        preferBuildingName: '',
        preferPhone: '',
        preferPhoneMobile: '',
        sameAsResidence: true
    },
    preference: '',
    selfPromotion: '',
    motivation: '',
    creationDate: {
        year: today.getFullYear().toString(),
        month: (today.getMonth() + 1).toString(),
        day: today.getDate().toString(),
        isEmpty: false,
        isCustomDate: false,
        isLastModifiedDate: true
    },
    guardian: {
        fullName: '',
        fullNameKana: '',
        zip: '',
        address: '',
        addressKana: '', // addressKana currently not in use
        buildingName: '',
        phone: '',
        email: ''
    },
    photo: '',
    lastModifiedDate: ''
};
export const INITIAL_FULLTIME_RESUME = {
    type: 'fulltime',
    resumeName: '',
    basicInfo: {
        lastName: '',
        lastNameKana: '',
        firstName: '',
        firstNameKana: '',
        birthYear: '1990',
        birthMonth: '1',
        birthDay: '1',
        gender: 2,
        genderString: '',
        email: ''
    },
    education: [],
    employment: [],
    certifications: [],
    contact: {
        zip: '',
        address: '',
        addressKana: '',
        buildingName: '',
        phone: '',
        phoneMobile: '',
        preferZip: '',
        preferAddress: '',
        preferAddressKana: '',
        preferBuildingName: '',
        preferPhone: '',
        preferPhoneMobile: '',
        sameAsResidence: true
    },
    preference: '',
    selfPromotion: '',
    motivation: '',
    creationDate: {
        year: today.getFullYear().toString(),
        month: (today.getMonth() + 1).toString(),
        day: today.getDate().toString(),
        isEmpty: false,
        isCustomDate: false,
        isLastModifiedDate: true
    },
    photo: '',
    workSummary: '',
    skills: [],
    languages: [],
    lastModifiedDate: ''
};
export const INITIAL_STATE = {
    type: 'parttime',
    resumeName: '',
    basicInfo: {
        lastName: '',
        lastNameKana: '',
        firstName: '',
        firstNameKana: '',
        birthYear: '1990',
        birthMonth: '1',
        birthDay: '1',
        gender: 2,
        genderString: '',
        email: ''
    },
    education: [],
    employment: [],
    certifications: [],
    contact: {
        zip: '',
        address: '',
        addressKana: '',
        buildingName: '',
        phone: '',
        phoneMobile: '',
        preferZip: '',
        preferAddress: '',
        preferAddressKana: '',
        preferBuildingName: '',
        preferPhone: '',
        preferPhoneMobile: '',
        sameAsResidence: true
    },
    preference: '',
    selfPromotion: '',
    motivation: '',
    creationDate: {
        year: today.getFullYear().toString(),
        month: (today.getMonth() + 1).toString(),
        day: today.getDate().toString(),
        isEmpty: false,
        isCustomDate: false,
        isLastModifiedDate: true
    },
    guardian: {
        fullName: '',
        fullNameKana: '',
        zip: '',
        address: '',
        addressKana: '', // addressKana currently not in use
        buildingName: '',
        phone: '',
        email: ''
    },
    photo: '',
    lastModifiedDate: ''
};
export const INITIAL_PROFILE = {
    firstName: '',
    lastName: '',
    firstNameFurigana: '',
    lastNameFurigana: '',
    phoneNumber: '',
    dateOfBirth: {
        year: '1990',
        month: '01'
    },
    gender: 2,
    summary: '',
    location: {
        postalCode: '',
        unknownLocation: '',
        address: '',
        address2: ''
    },
    educations: [],
    workExperiences: [],
    certifications: [],
    skills: [],
    dateCreated: Date.now()
};
export const HOME_PROFILE_MODAL_KEY = 'home_profile_modal_shown';
// --------------------------------------
// DEMO EDUCATION/EMPLOYMENT FIELDS:
// name: "",
// inProgress: false,
// startMonth: "4",
// startYear: "2015",
// startReason: START_REASONS.入学,
// endMonth: "3",
// endYear: "2018",
// endReason: END_REASONS.卒業,
// DEMO CERTIFICATION FIELDS:
// name: type,
// obtainMonth: "8",
// obtainYear: "2015",
// obtainReason: OBTAIN_REASONS.取得,
// "basicInfo": {
//     "lastName": "田中",
//     "lastNameKana": "たなか",
//     "firstName": "リュウキ",
//     "firstNameKana": "りゅうき",
//     "birthYear": "1985",
//     "birthMonth": "3",
//     "birthDay": "24",
//     "gender": 1,
//     "email": "ryuki_lovesxXxramen32_@i.softbank.jp"
// },
// "education": [
//     {
//         "name": "市立中学校",
//         "inProgress": False,
//         "startMonth": "4",
//         "startYear": "2008",
//         "startReason": "入学",
//         "endMonth": "3",
//         "endYear": "2011",
//         "endReason": "卒業"
//     },
//     {
//         "name": "埼玉県高学校 埼玉県高学校 埼玉県高学校 普通料",
//         "inProgress": False,
//         "startMonth": "4",
//         "startYear": "2011",
//         "startReason": "入学",
//         "endMonth": "3",
//         "endYear": "2014",
//         "endReason": "退学"
//     },
//     {
//         "name": "東京大学経済学部 経済学科",
//         "inProgress": True,
//         "startMonth": "4",
//         "startYear": "2014",
//         "startReason": "入学",
//         "endMonth": "3",
//         "endYear": "2017",
//         "endReason": ""
//     }
// ],
// "employment": [
//     {
//         "name": "株式会社パート",
//         "inProgress": False,
//         "startMonth": "8",
//         "startYear": "2017",
//         "startReason": "入社",
//         "endMonth": "12",
//         "endYear": "2018",
//         "endReason": "退社"
//     },
//     {
//         "name": "COMAPNY 1",
//         "inProgress": False,
//         "startMonth": "2",
//         "startYear": "2019",
//         "startReason": "入社",
//         "endMonth": "3",
//         "endYear": "",
//         "endReason": "一身上の都合により退社"
//     },
//     {
//         "name": "COMAPNY 2",
//         "inProgress": True,
//         "startMonth": "2",
//         "startYear": "2019",
//         "startReason": "入社",
//         "endMonth": "3",
//         "endYear": "",
//         "endReason": "一身上の都合により退社"
//     }
// ],
// "certifications": [
//     {
//         "name": "TOEIC公開テスト350点",
//         "obtainMonth": "8",
//         "obtainYear": "2015",
//         "obtainReason": "取得"
//     },
//     {
//         "name": "普通自動車第一種運転免許",
//         "obtainMonth": "2",
//         "obtainYear": "2018",
//         "obtainReason": "取得"
//     },
//     {
//         "name": "TOEIC公開テスト350点",
//         "obtainMonth": "8",
//         "obtainYear": "2015",
//         "obtainReason": "取得"
//     },
//     {
//         "name": "TOEIC公開テスト350点",
//         "obtainMonth": "8",
//         "obtainYear": "2015",
//         "obtainReason": "取得"
//     },
//     {
//         "name": "TOEIC公開テスト350点",
//         "obtainMonth": "8",
//         "obtainYear": "2015",
//         "obtainReason": "取得"
//     },
//     {
//         "name": "TOEIC公開テスト350点",
//         "obtainMonth": "8",
//         "obtainYear": "2015",
//         "obtainReason": "取得"
//     },
//     {
//         "name": "TOEIC公開テスト350点",
//         "obtainMonth": "8",
//         "obtainYear": "2015",
//         "obtainReason": "取得"
//     },
//     {
//         "name": "TOEIC公開テスト350点",
//         "obtainMonth": "8",
//         "obtainYear": "2015",
//         "obtainReason": "取得"
//     },
// ],
// "contact": {
//     "zip": "1580093",
//     "address": "東京都世田谷区等々力3-5-16",
//     "addressKana": "とうきょうせたがやくとどろき4-5-16とどろきはうす502",
//     "buildingName": "等々力ハウス502",
//     "phone": "090-234-435",
//     "phoneMobile": "090-235-123",
//     "preferZip": "a",
//     "preferAddress": "e",
//     "preferAddressKana": "d",
//     "preferBuildingName": "r",
//     "preferPhone": "h",
//     "preferPhoneMobile": "haha",
//     "sameAsResidence": False
// },
// "preference": "毎週火・金曜は大学の従業が休みなので、フルタイムで勤務可能です。",
// "selfPromotion": "高校時代から、学校の勉強や趣味でパソコンを使っていたので、ワードやエクセルなどはスムーズに使いこなせます。特にエクセルは複雑な関数も使用経験がありますので、様々な衣類の対応できるかと思います。",
// "motivation": "経理や計算に興味があり、パソコンで書類を制作することも好きです。ゆくゆくは資格を取りたいと思っています。働きながら資格を取得できるこちらの会社で、事務の業務を、一から学ばせて頂ければと思います。",
// "creationDate": {
//     "year": "2019",
//     "month": "10",
//     "day": "33"
// },
// "guardian": {
//     "fullName": "zhang chen",
//     "fullNameKana": "chen zhang",
//     "zip": "0000",
//     "address": "皇居",
//     "addressKana": "ko kyo",
//     "buildingName": "king's landing",
//     "phone": "0000",
//     "email": "iamking@king.com"
// },
// "other": {
//     "commuteHours": "2",
//     "commuteMinutes": "2",
//     "commuteType": "",
//     "numDependants": "0",
//     "spouse": 1,
//     "spouseDependent": 1
// },
// "photo": ""
